import "./App.css";
import { BrowserRouter as Router, Route, Routes, useLocation } from "react-router-dom";
import MainLayout from "./components/layout/MainLayout";
import { adminRoutes, routes } from "./routes";
import { AddFeature } from "./pages/settings/fleet/features/AddFeature"
import { EditFeature } from "./pages/settings/fleet/features/EditFeature"
import { AddRepairOrder } from "./pages/fleet/repairOrder/AddRepairOrder";
import { EditRepariOrder } from "./pages/fleet/repairOrder/EditRepariOrder";
import { AddCustomer } from "./pages/contacts/customers/AddCustomer";
import { EditCustomer } from "./pages/contacts/customers/EditCustomer";
import { AdminMainLayout } from "./components/layout/AdminMainLayout";
import { AddBranch } from "./pages/settings/fleet/branches/AddBranch";
import EditBranch from "./pages/settings/fleet/branches/EditBranch";
import { AddSeasons } from "./pages/settings/carrental/seasons/AddSeasons";
import { EditSeasons } from "./pages/settings/carrental/seasons/EditSeasons";
import { AddRates } from "./pages/settings/carrental/rates/AddRates";
import { EditRates } from "./pages/settings/carrental/rates/EditRates";
import { AddUser } from "./pages/settings/usermanagement/users/AddUser";
import EditVehicleClass from "./pages/settings/fleet/vehicleClass/EditVehicleClass";
import { UpdateUsers } from "./pages/settings/usermanagement/users/UpdateUsers";
import { AddVehicleClass } from "./pages/settings/fleet/vehicleClass/AddVehicleClass";
import { AddAdditionalCharges } from "./pages/settings/carrental/additionalCharges/AddAdditionalCharges";
import { EditAdditionalCharges } from "./pages/settings/carrental/additionalCharges/EditAdditionalCharges";
import { AddDiscounts } from "./pages/settings/carrental/discounts/AddDiscounts";
import { EditDiscounts } from "./pages/settings/carrental/discounts/EditDiscounts";
import { AddSecurityDeposits } from "./pages/settings/carrental/securityDeposits/AddSecurityDeposits";
import { EditSecurityDeposits } from "./pages/settings/carrental/securityDeposits/EditSecurityDeposits";
import { AddEmailTemplate } from "./pages/settings/carrental/emailTemplates/AddEmailTemplate";
import EditEmailTemplate from "./pages/settings/carrental/emailTemplates/EditEmailTemplate";
import { AddVehicleType } from "./pages/settings/fleet/vehicleTypes/AddVehicleType";
import { EditVehicleType } from "./pages/settings/fleet/vehicleTypes/EditVehicleType";
import { AddVehicleModel } from "./pages/settings/fleet/vehicleModel/AddVehicleModel";
import { EditVehicleModel } from "./pages/settings/fleet/vehicleModel/EditVehicleModel";
import { AddVehicleMake } from "./pages/settings/fleet/vehicleMake/AddVehicleMake";
import { EditVehicleMake } from "./pages/settings/fleet/vehicleMake/EditVehicleMake";
import { AddVehicleEngine } from "./pages/settings/fleet/vehicleEngines/AddVehicleEngine";
import { EditVehicleEngine } from "./pages/settings/fleet/vehicleEngines/EditVehicleEngine";
import { AddFleetLocation } from "./pages/settings/fleet/fleetLocations/AddFleetLocation";
import { EditFleetLocation } from "./pages/settings/fleet/fleetLocations/EditFleetLocation";
import Login from "./components/login/Login";
import RequireAuth from "./components/login/RequireAuth";
import { AuthProvider } from "./components/context/AuthProvider";
import PrintQuotes from "./pages/carrental/reservations/PrintQuotes";
import { PaymentGatewaysForm } from "./pages/settings/paymentGateways/gateways/PaymentGatewaysForm";
import { EditPaymentGatewaysForm } from "./pages/settings/paymentGateways/gateways/EditPaymentGatewaysForm";
import ForgotPassword from "./components/login/ForgotPassword";
import { AccessControlProvider } from "./components/context/AccessControlProvider";
import Home from "./pages/home/Home";
import Header from "./components/Header";
import { ActiveNavBarProvider } from "./components/context/ActiveNavBarProvider";
import Footer from "./components/Footer";
import Features from "./pages/features/Features";
import Security from "./pages/resources/Security";
import CaseStudies from "./pages/resources/CaseStudies";
import ContactUs from "./pages/resources/ContactUs";
import Faq from "./pages/faq/Faq";
import Blog from "./pages/resources/blog/Blog";
import RentalSoftware from "./pages/resources/blog/RentalSoftware";
import RentalSoftwareBenefits from "./pages/resources/blog/RentalSoftwareBenefits";
import RentalBusinessOperations from "./pages/resources/blog/RentalBusinessOperations";
import ScrollToTop from "./components/ScrollToTop";
import Pricing from "./pages/pricing/Pricing";
import FreeTrial from "./pages/pricing/FreeTrial";
import { RouteType } from "./routes/config";
import appRoutes from "./routes/appRoutes";
import Checkout from "./pages/pricing/Checkout";
import QuickPayView from "./pages/billPay/QuickPayView";
import { DeleteProvider } from "./components/context/DeleteProvider";
import ThankYou from "./pages/pricing/ThankYou";
import { SupportTickets } from "./pages/settings/supportTickets/SupportTickets";
import NewSupportTicket from "./pages/settings/supportTickets/NewSupportTicket";
import { AttachmentProvider } from "./components/context/AttachmentProvider";
import EditSupportTicket from "./pages/settings/supportTickets/EditSupportTicket";
import { QuickLinksProvider } from "./components/context/QuickLinksProvider";
import PrivacyPolicy from "./pages/importantLinks/PrivacyPolicy";
import { ConfirmProvider } from "./components/context/ConfirmProvider";
import { ProfileProvider } from "./components/context/ProfileProvider";
import { AddDailyNotes } from "./pages/dailyNotes/AddDailyNotes";
import { ViewDailyNotes } from "./pages/dailyNotes/ViewDailyNotes";
import { ThemeProvider } from "./components/context/ThemeProvider";
import { GeneralProvider } from "./components/context/GeneralProvider";
import { AddEmailTemplateType } from "./pages/settings/carrental/emailTemplateTypes/AddEmailTemplateType";
import { EditEmailTemplateType } from "./pages/settings/carrental/emailTemplateTypes/EditEmailTemplateType";
import { EditVehicle } from "./pages/fleet/vehicles/EditVehicles";
import { AddVehicle } from "./pages/fleet/vehicles/AddVehicles";
import { AddReservation } from "./pages/carrental/reservations/AddReservation";
import { EditReservation } from "./pages/carrental/reservations/EditReservation";
import { AddAddOnCategory } from "./pages/settings/carrental/addOnCategory/AddAddOnCategory";
import { EditAddOnCategory } from "./pages/settings/carrental/addOnCategory/EditAddOnCategory";
import { CreateRepairOrder } from "./pages/fleet/maintenance/CreateRepairOrder";
import { AddMaintenanceTypes } from "./pages/settings/fleet/maintenance/maintenanceTypes/AddMaintenanceTypes";
import { EditMaintenanceTypes } from "./pages/settings/fleet/maintenance/maintenanceTypes/EditMaintenanceTypes";
import { AddDamageTypes } from "./pages/settings/fleet/maintenance/damageTypes/AddDamageTypes";
import { EditDamageTypes } from "./pages/settings/fleet/maintenance/damageTypes/EditDamageTypes";
import PageNotFoundType2 from "./pages/notFound/PageNotFoundType2";
import PrintRentalAgreementView from "./pages/carrental/reservations/PrintRentalAgreementView";
import PrintReceiptView from "./pages/carrental/reservations/PrintReceiptView";
import UnAuthorize2 from "./components/login/UnAuthorize2";
import TermsOfService from "./pages/importantLinks/TermsOfService";
import { AddFaq } from "./pages/settings/admin/websiteSettings/websiteFaq/AddFaq";
import { EditFaq } from "./pages/settings/admin/websiteSettings/websiteFaq/EditFaq";
import { AddExpenseTypes } from "./pages/settings/fleet/maintenance/expenseTypes/AddExpenseTypes";
import { EditExpenseTypes } from "./pages/settings/fleet/maintenance/expenseTypes/EditExpenseTypes";
import { AddRelocationMapping } from "./pages/settings/fleet/relocationMapping/AddRelocationMapping";
import { EditRelocationMapping } from "./pages/settings/fleet/relocationMapping/EditRelocationMapping";
import AddVehicleMaintenanceRule from "./pages/settings/fleet/vehicleMaintenanceRules/AddVehicleMaintenanceRule";
import EditVehicleMaintenanceRule from "./pages/settings/fleet/vehicleMaintenanceRules/EditVehicleMaintenanceRule";
import { TenantProvider } from "./components/context/TenantProvider";
import { ToastProvider } from "./components/context/ToastProvider";
import { PaymentRequests } from "./pages/carrental/payments/PaymentRequests";
import ViewEmailBody from "./pages/settings/logs/emailsSent/ViewEmailBody";
import { AddVendor } from "./pages/vendorsManagement/AddVendor";
import { EditVendor } from "./pages/vendorsManagement/EditVendor";


const Roles = {
  Admin: "Admin",
}

function App() {
  return (
    <Router>
      <ScrollToTop />
      <ToastProvider>
        <TenantProvider>
          <AuthProvider>
            <ActiveNavBarProvider>
              <AttachmentProvider>
                <QuickLinksProvider>
                  <ConfirmProvider>
                    <DeleteProvider>
                      <ProfileProvider>
                        <AccessControlProvider>
                          <ThemeProvider>
                            <GeneralProvider>
                              <AppWithLocation />
                            </GeneralProvider>
                          </ThemeProvider>
                        </AccessControlProvider>
                      </ProfileProvider>
                    </DeleteProvider>
                  </ConfirmProvider>
                </QuickLinksProvider>
              </AttachmentProvider>
            </ActiveNavBarProvider>
          </AuthProvider>
        </TenantProvider>
      </ToastProvider>
    </Router>
  );
}

function AppWithLocation() {
  const location = useLocation();

  const extractAllPaths = (routes: RouteType[]): string[] => {
    const paths: string[] = [];
    const traverseRoutes = (routes: RouteType[]) => {
      routes.forEach(route => {
        if (route.path) paths.push(route.path);
        if (route.child) traverseRoutes(route.child);
      });
    };
    traverseRoutes(routes);
    return paths;
  };

  const allPaths = [...extractAllPaths(appRoutes), '/support'];

  const shouldHideHeaderFooter = allPaths.some(
    path => location.pathname === path || location.pathname.startsWith(`${path}/`)
  );

  return (
    <>
      {!shouldHideHeaderFooter && <Header />}
      <Routes>
        <Route path="*" element={<PageNotFoundType2 />} />
        <Route path="/unauthorized" element={<UnAuthorize2 />} />

        <Route path="/" element={<Home />} />
        <Route path="/features" element={<Features />} />
        <Route path="/security" element={<Security />} />
        <Route path="/blog" element={<Blog />} />
        <Route path="/blog/vehicle-rental-management-software" element={<RentalSoftware />} />
        <Route path="/blog/fleet-management-rental-software" element={<RentalSoftwareBenefits />} />
        <Route path="/blog/rental-business-automation" element={<RentalBusinessOperations />} />
        <Route path="/case-studies" element={<CaseStudies />} />
        <Route path="/contact-us" element={<ContactUs />} />
        <Route path="/terms-of-service" element={<TermsOfService />} />
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
        <Route path="/faq" element={<Faq />} />
        <Route path="/pricing" element={<Pricing />} />
        <Route path="/quick-pay/:accountNumber" element={<QuickPayView />} />
        <Route path="/free-trial" element={<FreeTrial />} />
        <Route path="/checkout" element={<Checkout />} />
        <Route path="/checkout/thank-you" element={<ThankYou />} />

        <Route path="login" element={<Login />} />
        <Route path="/forgot-password" element={<ForgotPassword />} />

        <Route element={<RequireAuth roles={[Roles.Admin]} />}>
          <Route path="/" element={<MainLayout />}>
            {routes}
            <Route path="/fleet/vehicle/addvehicles" element={<AddVehicle />} />
            <Route
              path="/fleet/vehicle/editvehicles"
              element={<EditVehicle />}
            />
            <Route
              path="/fleet/repairorders/addrepairorder"
              element={<AddRepairOrder />}
            />
            <Route
              path="/fleet/repairorders/editrepairorder"
              element={<EditRepariOrder />}
            />
            <Route
              path="/fleet/maintenance/createrepairorder"
              element={<CreateRepairOrder />}
            />
            <Route
              path="/contacts/customers/addcustomer"
              element={<AddCustomer />}
            />
            <Route
              path="/contacts/customers/editcustomer"
              element={<EditCustomer />}
            />
            <Route
              path="/vendorsmanagement/vendors/addvendor"
              element={<AddVendor />}
            />
            <Route
              path="/vendorsmanagement/vendors/editvendor"
              element={<EditVendor />}
            />
            <Route
              path="/carrental/reservations/addreservation"
              element={<AddReservation />}
            />
            <Route
              path="/carrental/reservations/editreservation"
              element={<EditReservation />}
            />
            <Route
              path="/carrental/payments/paymentrequests"
              element={<PaymentRequests />}
            />
            <Route
              path="/support/support-tickets"
              element={<SupportTickets />}
            />
            <Route
              path="/support/new-support-ticket"
              element={<NewSupportTicket />}
            />
            <Route
              path="/support/edit-support-ticket/:id"
              element={<EditSupportTicket />}
            />
            <Route
              path="/daily-notes/add-daily-notes"
              element={<AddDailyNotes />}
            />
            <Route
              path="/daily-notes/view-daily-notes/:id"
              element={<ViewDailyNotes />}
            />
          </Route>
        </Route>

        <Route element={<RequireAuth roles={[Roles.Admin]} />}>
          <Route path="/admin" element={<AdminMainLayout />}>
            {adminRoutes}
            <Route
              path="/admin/websitesettings/faq/addFaq"
              element={<AddFaq />}
            />
            <Route
              path="/admin/websitesettings/faq/editFaq"
              element={<EditFaq />}
            />
            <Route
              path="/admin/usermanagement/users/adduser"
              element={<AddUser />}
            />
            <Route
              path="/admin/usermanagement/users/edituser"
              element={<UpdateUsers />}
            />
            <Route
              path="/admin/fleet/branches/addbranch"
              element={<AddBranch />}
            />
            <Route
              path="/admin/fleet/branches/editbranch"
              element={<EditBranch />}
            />
            <Route
              path="/admin/fleet/vehicleclasses/addvehicleclasses"
              element={<AddVehicleClass />}
            />
            <Route
              path="/admin/fleet/vehicleclasses/editvehicleclasses"
              element={<EditVehicleClass />}
            />
            <Route
              path="/admin/carrental/seasons/addseason"
              element={<AddSeasons />}
            />
            <Route
              path="/admin/carrental/seasons/editseason"
              element={<EditSeasons />}
            />
            <Route
              path="/admin/carrental/rates/addrates"
              element={<AddRates />}
            />
            <Route
              path="/admin/carrental/rates/editrates"
              element={<EditRates />}
            />
            <Route
              path="/admin/carrental/addoncategories/addaddoncategories"
              element={<AddAddOnCategory />}
            />
            <Route
              path="/admin/carrental/addoncategories/editaddoncategories"
              element={<EditAddOnCategory />}
            />
            <Route
              path="/admin/carrental/additionalcharges/addadditionalCharges"
              element={<AddAdditionalCharges />}
            />
            <Route
              path="/admin/carrental/additionalcharges/editadditionalCharges"
              element={<EditAdditionalCharges />}
            />
            <Route
              path="/admin/carrental/discounts/adddiscount"
              element={<AddDiscounts />}
            />
            <Route
              path="/admin/carrental/discounts/editdiscount"
              element={<EditDiscounts />}
            />
            <Route
              path="/admin/carrental/securitydeposits/addsecuritydeposit"
              element={<AddSecurityDeposits />}
            />
            <Route
              path="/admin/carrental/securitydeposits/editsecuritydeposit"
              element={<EditSecurityDeposits />}
            />
            <Route
              path="/admin/carrental/emailtemplatetypes/addemailtemplatetype"
              element={<AddEmailTemplateType />}
            />
            <Route
              path="/admin/carrental/emailtemplatetypes/editemailtemplatetype"
              element={<EditEmailTemplateType />}
            />
            <Route
              path="/admin/carrental/emailtemplates/addemailtemplate"
              element={<AddEmailTemplate />}
            />
            <Route
              path="/admin/carrental/emailTemplates/editTemplates"
              element={<EditEmailTemplate />}
            />
            <Route
              path="/admin/fleet/vehicletypes/addvehicletype"
              element={<AddVehicleType />}
            />
            <Route
              path="/admin/fleet/vehicleTypes/editVehicleType"
              element={<EditVehicleType />}
            />
            <Route
              path="/admin/fleet/vehiclemake/addvehiclemake"
              element={<AddVehicleMake />}
            />
            <Route
              path="/admin/fleet/vehiclemake/editVehicleMake"
              element={<EditVehicleMake />}
            />
            <Route
              path="/admin/fleet/vehiclemodel/addvehiclemodel"
              element={<AddVehicleModel />}
            />
            <Route
              path="/admin/fleet/vehiclemodel/editvehiclemodel"
              element={<EditVehicleModel />}
            />
            <Route
              path="/admin/fleet/vehicleengines/addvehicleengine"
              element={<AddVehicleEngine />}
            />
            <Route
              path="/admin/fleet/vehicleengines/editvehicleengine"
              element={<EditVehicleEngine />}
            />
            <Route
              path="/admin/fleet/features/addfeature"
              element={<AddFeature />}
            />
            <Route
              path="/admin/fleet/features/editfeature"
              element={<EditFeature />}
            />
            <Route
              path="/admin/fleet/maintenance/addmaintenancetype"
              element={<AddMaintenanceTypes />}
            />
            <Route
              path="/admin/fleet/maintenance/editmaintenancetype"
              element={<EditMaintenanceTypes />}
            />
            <Route
              path="/admin/fleet/maintenance/adddamagetype"
              element={<AddDamageTypes />}
            />
            <Route
              path="/admin/fleet/maintenance/editdamagetype"
              element={<EditDamageTypes />}
            />
            <Route
              path="/admin/fleet/maintenance/addexpensetype"
              element={<AddExpenseTypes />}
            />
            <Route
              path="/admin/fleet/maintenance/editexpensetype"
              element={<EditExpenseTypes />}
            />
            <Route
              path="/admin/fleet/maintenancerules/addmaintenancerules"
              element={<AddVehicleMaintenanceRule />}
            />
            <Route
              path="/admin/fleet/maintenancerules/editmaintenancerules"
              element={<EditVehicleMaintenanceRule />}
            />
            <Route
              path="/admin/fleet/fleetlocations/addfleetlocation"
              element={<AddFleetLocation />}
            />
            <Route
              path="/admin/fleet/fleetlocations/editfleetlocation"
              element={<EditFleetLocation />}
            />
            <Route
              path="/admin/fleet/relocationMapping/addrelocationMapping"
              element={<AddRelocationMapping />}
            />
            <Route
              path="/admin/fleet/relocationMapping/editrelocationMapping"
              element={<EditRelocationMapping />}
            />
            <Route
              path="/admin/paymentgateways/paymentgatewaysform"
              element={<PaymentGatewaysForm />}
            />
            <Route
              path="/admin/paymentgateways/editpaymentgatewaysform"
              element={<EditPaymentGatewaysForm />}
            />
          </Route>
        </Route>

        {/* Print view */}
        <Route
          path="/carrental/reservations/print-quote"
          element={<PrintQuotes />}
        />

        <Route path="/admin/logs/emailssent/view/:id"
          element={<ViewEmailBody />} />

        <Route
          path="/carrental/reservations/print-agreement"
          element={<PrintRentalAgreementView />}
        />

        <Route
          path="/carrental/reservations/print-receipt"
          element={<PrintReceiptView />}
        />

      </Routes>
      {!shouldHideHeaderFooter && <Footer />}
    </>
  );
}

export default App;